import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteUserMutationProps = {
	idToBeRemoved: number | null
	setIdToBeRemoved: (id: number | null) => void
	closeDeleteModal: () => void
}

export const useDeleteUserMutation = ({
	idToBeRemoved,
	setIdToBeRemoved,
	closeDeleteModal
}: UseDeleteUserMutationProps) => {
	const axiosPrivate = useAxiosPrivate()
	const { t } = useTranslation()
	const queryClient = useQueryClient()

	const { mutate: deleteUserMutation } = useMutation({
		mutationFn: () => {
			// TODO: change to apiRoutes
			return axiosPrivate.delete(`/accounts/${idToBeRemoved}/`)
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('User deleted')
			})()

			queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
			setIdToBeRemoved(null)
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			closeDeleteModal()
		}
	})

	return {
		deleteUserMutation
	}
}
